import { buildScheduleRecurrenceSummary } from './scheduleRecurrenceSummary';

import type IMonitoringRun from 'constants/interfaces/IMonitoringRun';
import type { TMonitoringRunStatus } from 'constants/interfaces/IMonitoringRun';
import type IMonitoringSchedule from 'constants/interfaces/IMonitoringSchedule';

export const filterMonitoringSchedulesByType = (
  schedules: IMonitoringSchedule[],
  sessionType: string,
): IMonitoringSchedule[] => (
  schedules.filter((schedule) => schedule.sessionType === sessionType)
);

export const filterMonitoringSchedulesBySearch = (
  schedules: IMonitoringSchedule[],
  search: string,
): IMonitoringSchedule[] => {
  const query = search.trim().toLowerCase();

  if (!query) {
    return schedules;
  }

  return schedules.filter((schedule) => {
    const haystack = [
      schedule.title,
      buildScheduleRecurrenceSummary(schedule.schedule),
      schedule.schedule.timezone,
      ...(schedule.entities || []).map((entity) => entity.name),
    ].join(' ').toLowerCase();

    return haystack.includes(query);
  });
};

export const filterMonitoringRuns = (
  runs: IMonitoringRun[],
  {
    statusFilter = 'all',
    dateRangeFrom = '',
    dateRangeTo = '',
  }: {
    statusFilter?: TMonitoringRunStatus | 'all',
    dateRangeFrom?: string,
    dateRangeTo?: string,
  },
): IMonitoringRun[] => (
  runs.filter((run) => {
    if (statusFilter !== 'all' && run.status !== statusFilter) {
      return false;
    }

    if (dateRangeFrom || dateRangeTo) {
      const runDate = run.scheduledAt?.slice(0, 10);

      if (!runDate) {
        return false;
      }

      if (dateRangeFrom && runDate < dateRangeFrom) {
        return false;
      }

      if (dateRangeTo && runDate > dateRangeTo) {
        return false;
      }
    }

    return true;
  })
);

export const formatMonitoringRunLabel = (scheduledAt?: string): string => {
  if (!scheduledAt) {
    return 'Run';
  }

  const date = new Date(scheduledAt);

  return `Run ${date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })}`;
};
